<section class="opening-requirements-btn" (click)="closeRequirements=!closeRequirements">
	<i class="fa fa-2x fas fa-bars"></i>
</section>
<aside class="password-requirements" id="passwordRequirements"
	   [ngClass]="closeRequirements ? 'closed-requirement' : ''">
	<div class="closing-requirements-btn" (click)="closeRequirements=!closeRequirements">
		<img src="../../../assets/img/{{themeService.theme}}/close-btn1.svg" alt="">
	</div>
	<div class="expanations-container">
		<div class="title">Password Requirements</div>
		<div class="subtitle">Your password must contain at least:</div>
		<div class="expanations-list">
			<label class="check-label">
				10 Characters
				<input type="checkbox" checked="checked" class="form-check-input">
				<span class="checkmark"
					  [ngClass]="singUpForm.controls['password'].hasError('required') || singUpForm.controls['password'].hasError('minlength')  ? 'background-danger' : 'background-success'"></span>
			</label>
			<label class="check-label">
				1 Upper Case Character
				<input type="checkbox" checked="checked" class="form-check-input">
				<span class="checkmark"
					  [ngClass]="singUpForm.controls['password'].hasError('required') || singUpForm.controls['password'].hasError('hasCapitalCase')  ? 'background-danger' : 'background-success'"></span>
			</label>
			<label class="check-label">
				1 Lower Case Character
				<input type="checkbox" checked="checked" class="form-check-input">
				<span class="checkmark"
					  [ngClass]="singUpForm.controls['password'].hasError('required') || singUpForm.controls['password'].hasError('hasSmallCase')  ? 'background-danger' : 'background-success'"></span>
			</label>
			<label class="check-label">
				1 Number
				<input type="checkbox" checked="checked" class="form-check-input">
				<span class="checkmark"
					  [ngClass]="singUpForm.controls['password'].hasError('required') || singUpForm.controls['password'].hasError('hasNumber')  ? 'background-danger' : 'background-success'"></span>
			</label>
			<label class="check-label">
				1 Special Character
				<input type="checkbox" checked="checked" class="form-check-input">
				<span class="checkmark"
					  [ngClass]="singUpForm.controls['password'].hasError('required') || singUpForm.controls['password'].hasError('hasSpecialSymbol')  ? 'background-danger' : 'background-success'"></span>
			</label>
		</div>
	</div>
</aside>
<section class="container sign-container reset-password-container">
	<img class="sign-in-background" src="../../../assets/img/{{themeService.theme}}/zp-lg-background.png" alt="">
    <section class="navbar-brand">
        <img src="../../assets/img/{{themeService.theme}}/scd-logo.png" alt="Company Logo" width="125px">
    </section>
    <!-- <div class="sign-account" [routerLink]="['/sign-up']">Don't have an account? Sign Up</div> -->
    <section class="container">
        <form [formGroup]="singUpForm" (ngSubmit)="onSubmit()">
            <h1 class="serif-title">Reset Password</h1>
            <section class="sign-get-info">
                <div class="form-group caps-lock-section">
                    <input [type]="statusPassword ? 'text' : 'password'" class="form-control" id="password"
                        placeholder="Password" formControlName="password"
                        [ngClass]="{ 'is-invalid': submitted && f.password.errors }" required (capsLock)="capsOn=$event">
                    <i class="caps-lock-icon fa fas fa-eye" (click)="statusPassword = !statusPassword"></i>
                    <i class="caps-lock-icon fa fas fa-eye-slash" (click)="statusPassword = !statusPassword"
                        [ngClass]="!statusPassword ? 'eye-slash' : '' "></i>
                    <div *ngIf="capsOn" class="warning-caps-locked">Caps Locked</div>
                    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
						<div *ngIf="f.password.errors.required">Password is required</div>
						<div *ngIf="f.password.errors.minlength">Must be at least 10 characters</div>
						<div *ngIf="f.password.errors.hasCapitalCase">Must contain at least 1 in Capital Case</div>
						<div *ngIf="f.password.errors.hasSmallCase">Must contain at least 1 in Small Case</div>
						<div *ngIf="f.password.errors.hasNumber">Must contain at least 1 number</div>
						<div *ngIf="f.password.errors.hasSpecialSymbol">Must contain at least 1 special character</div>
					</div>
                </div>
                <div class="form-group caps-lock-section">
                    <input [type]="statusconfirmPassword ? 'text' : 'password'" class="form-control" id="confirmPassword"
                        placeholder="Confirm Password" formControlName="confirmPassword"
                        [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" required (capsLock)="capsOn=$event">
                    <i class="caps-lock-icon fa fas fa-eye" (click)="statusconfirmPassword = !statusconfirmPassword"></i>
                    <i class="caps-lock-icon fa fas fa-eye-slash" (click)="statusconfirmPassword = !statusconfirmPassword"
                        [ngClass]="!statusconfirmPassword ? 'eye-slash' : '' "></i>
                    <div *ngIf="capsOn" class="warning-caps-locked">Caps Locked</div>
                    <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
                        <div *ngIf="f.confirmPassword.errors.required">You must confirm your password</div>
					</div>
					<div *ngIf="submitted && !confirmPasswordValidator">
					 	<div class="warning-caps-locked">Your password confirmation must be the same as your password.</div>	
					</div>
                </div>
                <input type="submit" class="form-control btn btn-primary primary-default-btn" value="Reset password">
            </section>
        </form>
    </section>
</section>
<app-footer></app-footer>